import { Feature } from '@otto-ec/tracking-bct';

export interface GetProductFeaturesForNonPdpPageParams {
    variationId: string;
}

export const getProductFeaturesForNonPdpPage = ({ variationId }: GetProductFeaturesForNonPdpPageParams): Feature[] => {
    const productFeatureId = `P_${variationId}`;
    const businessDimensionFeatureId = `BD_${variationId}`;
    const variationFeatureId = `V_${variationId}`;

    return [
        {
            id: productFeatureId,
            name: 'Product',
            status: 'visible',
        },
        {
            id: businessDimensionFeatureId,
            parentId: productFeatureId,
            name: 'Business-Dimension',
            position: 1,
            status: 'visible',
            labels: {},
        },
        {
            id: variationFeatureId,
            parentId: businessDimensionFeatureId,
            name: 'Variation',
            position: 1,
            status: 'visible',
            variationId,
            labels: {},
        },
    ];
};
